(() => {
  const priceSelector = [
    'span.money',
    '[class*="money"]',
    '.price-item',
    '.product-price',
    '[class*="price"]',
    '[class*="subtotal"]',
    '[class*="total"]',
    '.previewCartItem-price .price',
    '.previewCartTotals-value',
    '.cart-total-value',
    '.cart-item-value',
    '.cart-popup-subtotal strong',
    '[data-item-final-price-display]',
    '[data-item-original-price-display]',
    '[data-item-price-with-quantity-display]',
    '[data-cart-popup-subtotal]',
    '[data-cart-subtotal-value]',
    '[data-cart-total-value]',
    '[data-saved-discount-value]',
    '[data-cart-savings-message]',
    '[data-unit-price]',
    'td[headers*="Price"]',
    'td[headers*="Subtotal"]',
    'td[headers*="Total"]',
    'td[headers*="Shipping"]',
    'td[headers*="Tax"]'
  ].join(',');
  const amountPattern = /(^|[\s(])([−-]?\s*)((?:\d{1,3}(?:\.\d{3})+|\d+),\d{2})(?=$|[\s)])/g;
  const currencySuffixPattern = /((?:\d{1,3}(?:\.\d{3})+|\d+),\d{2})\s*[A-Z]{3}\b/gi;
  let frameId = 0;
  const pendingRoots = new Set();
  const formattedText = new WeakMap();
  const ignoredSelector = '.dm-price-currency, script, style, template';

  const syncFormatters = () => {
    const moneyTemplate = window.money_format;
    const currencyCode = window.shop_currency;

    if (moneyTemplate && currencyCode && window.Currency?.moneyFormats?.[currencyCode]) {
      window.Currency.moneyFormats[currencyCode].money_format = moneyTemplate;
      window.Currency.moneyFormats[currencyCode].money_with_currency_format = moneyTemplate;
    }
  };

  const prefixTextNode = (node) => {
    let value = node.nodeValue;
    if (formattedText.get(node) === value) return;
    const parent = node.parentElement;
    if (!parent || parent.closest(ignoredSelector)) return;
    if (!value || !/\d/.test(value)) return;

    const currencySymbol = window.currencySymbol || (window.shop_currency === 'BRL' ? 'R$' : '');
    if (!currencySymbol) return;

    value = value.replace(currencySuffixPattern, `${currencySymbol} $1`);
    value = value.replace(amountPattern, (match, spacing, sign, amount, offset, fullText) => {
      const before = fullText.slice(Math.max(0, offset - 5), offset + spacing.length);
      if (before.trimEnd().endsWith(currencySymbol)) return match;
      return `${spacing}${sign}${currencySymbol} ${amount}`;
    });

    formattedText.set(node, value);
    if (value !== node.nodeValue) node.nodeValue = value;
  };

  const formatElement = (element) => {
    if (!(element instanceof Element)) return;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(prefixTextNode);
  };

  const formatPrices = (root = document) => {
    syncFormatters();
    if (root instanceof Element && root.closest(ignoredSelector)) return;

    const elements = [];
    if (root instanceof Element && root.matches(priceSelector)) elements.push(root);
    if (root.querySelectorAll) elements.push(...root.querySelectorAll(priceSelector));

    const candidates = new Set(elements);
    const containers = new Set();
    elements.forEach((element) => {
      const ancestor = element.parentElement?.closest(priceSelector);
      if (candidates.has(ancestor)) containers.add(ancestor);
    });
    elements.forEach((element) => {
      if (!containers.has(element)) formatElement(element);
    });
  };

  const scheduleFormat = (root) => {
    if (!root || (root instanceof Element && root.closest(ignoredSelector))) return;
    pendingRoots.add(root);
    if (frameId) return;

    frameId = window.requestAnimationFrame(() => {
      frameId = 0;
      const roots = new Set(pendingRoots);
      pendingRoots.clear();
      syncFormatters();
      roots.forEach((candidate) => {
        if (!candidate.isConnected) return;
        if (candidate !== document && roots.has(document)) return;
        for (let ancestor = candidate.parentElement; ancestor; ancestor = ancestor.parentElement) {
          if (roots.has(ancestor)) return;
        }
        formatPrices(candidate);
      });
    });
  };

  const scheduleText = (node) => {
    if (!node.parentElement || formattedText.get(node) === node.nodeValue) return;
    if (!/\d/.test(node.nodeValue || '')) return;
    scheduleFormat(node.parentElement.closest(priceSelector));
  };

  const initialize = () => {
    formatPrices();

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          scheduleText(mutation.target);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            scheduleFormat(node);
          } else if (node.nodeType === Node.TEXT_NODE) {
            scheduleText(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.dmEnsureBrlPrices = formatPrices;
})();

